<script>
import Multiselect from 'vue-multiselect'
import {
  usersMethods,
  warehouseMethods,
  appSectionsMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'

let _ = require('lodash')

export default {
  name: 'GroupsUpdateForm',
  components: { Multiselect },
  props: {
    onformsubmit: {
      type: Function,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      appSectionsOptions: [],
      appSectionsOptionsCache: [],
      loadingAppSectionsOptions: false,
      appSectionsOptionsMounted: false,
      select_app_section: null,
      select_warehouse: {},
      select_ubication: {},
    }
  },
  mounted() {
    this.populateAppSectionsOptions()
    this.allWarehouse()
    this.select_warehouse = this.form.warehouse
    this.select_ubication = this.form.ubications
    this.select_app_section = this.form.permissions
    this.form.permissions = this.select_app_section.map((p) => p.id)
    this.form.loading = false
  },
  computed: {
    ...mapGetters({
      loading_warehouses: 'retina/warehouse/loading_warehouses',
      warehouses: 'retina/warehouse/warehouses',
    }),
    ubicationsOptions() {
      return this.form.warehouse
        ? this.warehouses.find(
            (warehouse) => warehouse.id == this.form.warehouse.id
          ).ubications
        : []
    },
  },
  methods: {
    ...usersMethods,
    ...warehouseMethods,
    ...appSectionsMethods,
    allWarehouse() {
      this.setLoadingWarehouses(true)
      return this.fetchWarehouses('')
        .then((data) => {
          this.setWarehouses(data.results)
          this.setLoadingWarehouses(false)
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          this.setWarehouses([])
          this.setLoadingWarehouses(false)
          return []
        })
    },
    selectWarehouseProccess() {
      this.form.warehouse = this.select_warehouse
      this.select_ubication = []
      this.form.ubications = []
    },
    selectUbicationProccess() {
      this.form.ubications = this.select_ubication
    },
    selectAppSectionProccess() {
      this.form.permissions = this.select_app_section.map((p) => p.id)
    },
    populateAppSectionsOptions(searchQuery) {
      let context = this
      context.loadingAppSectionsOptions = true
      let reqParams = context.$select_params(searchQuery)
      reqParams = `${reqParams}${
        !reqParams ? '?' : '&'
      }admin_required=false&app_permission__isnull=false`
      const promise = context.fetchAppSections(reqParams)
      return promise
        .then((data) => {
          let listOptions = []
          data.results.forEach((opt) => {
            let parentTreeName = ''
            if (opt.parent_tree.length - 1) {
              for (let i = 0; i < opt.parent_tree.length; i++) {
                if (i !== opt.parent_tree.length - 1) {
                  const el = opt.parent_tree[i]
                  parentTreeName = parentTreeName.concat(`${el.name} > `)
                }
              }
            }
            parentTreeName = parentTreeName.concat(opt.name)
            listOptions.push({
              id: opt.app_permission.permission.id,
              url: opt.url,
              name: opt.name,
              parentTreeName,
            })
          })
          context.appSectionsOptions = listOptions
          context.loadingAppSectionsOptions = false
          context.appSectionsOptionsMounted = true
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loadingAppSectionsOptions = false
          context.appSectionsOptionsMounted = true
        })
    },
    labelOfAppSections(opt) {
      let appSectionsOptionsFounded = this.appSectionsOptions.find(
        (x) => x.id === opt.id
      )
      if (!appSectionsOptionsFounded) {
        let cacheFounded = this.appSectionsOptionsCache.find(
          (x) => x.id === opt.id
        )
        return cacheFounded
          ? cacheFounded.parentTreeName
          : this.appSectionsOptionsMounted
          ? `Not found in options: ${opt}`
          : ''
      } else {
        return appSectionsOptionsFounded.parentTreeName
      }
    },
    asyncFindAppSections: _.debounce(function(searchQuery) {
      this.populateAppSectionsOptions(searchQuery)
    }, 600),
  },
}
</script>
<template>
  <div>
    <b-spinner v-if="loadingAppSectionsOptions" variant="primary" label="Spinning"></b-spinner>
    <b-form v-if="!loadingAppSectionsOptions" id="form" @submit="onformsubmit">
      <form-wrapper :validator="validator">
        <div>
          <form-summary />
        </div>
        <form-group name="name" label="Nombre">
          <b-form-input
            v-model="form.name"
            slot-scope="{ attrs, listeners }"
            v-bind="attrs"
            v-on="listeners"
          />
        </form-group>
        <form-group name="description" label="Descripción">
          <div>
            <b-form-textarea
              id="textarea"
              v-model="form.description"
              placeholder="Descripción"
            ></b-form-textarea>
          </div>
        </form-group>
        <b-form-group
          label="Bodegas:"
          label-cols-xl="2"
          :content-cols-xl="content_cols_xl"
        >
          <Multiselect
            v-if="!loading_warehouses"
            v-model="select_warehouse"
            :options="warehouses"
            placeholder="Seleccione una Bodega"
            label="description"
            track-by="description"
            @input="selectWarehouseProccess()"
            selectLabel="+"
            deselectLabel="×"
            selectedLabel=✔︎
          >
          </Multiselect>

          <div v-if="loading_warehouses">
            <h5>
              <!-- <span class="spinner-border spinner-border-sm text-info" small role="status"></span> -->
              <span class="spinner-border text-info" small role="status"></span>
              Cargando lista de bodegas...
            </h5>
          </div>
        </b-form-group>
        <b-form-group
          v-if="ubicationsOptions.length"
          label="Ubicaciones:"
          label-cols-xl="2"
          :content-cols-xl="content_cols_xl"
        >
          <Multiselect
            v-if="!loading_warehouses"
            v-model="select_ubication"
            :options="ubicationsOptions"
            :multiple="true"
            placeholder="Seleccione una ubicación"
            label="name"
            track-by="name"
            @input="selectUbicationProccess()"
            selectLabel="+"
            deselectLabel="×"
            selectedLabel=✔︎
          >
          </Multiselect>
          <div v-if="loading_warehouses">
            <h5>
              <span class="spinner-border text-info" role="status"></span>
              Cargando lista de ubicaciones...
            </h5>
          </div>
        </b-form-group>
        <form-group name="app-sections-select" label="Permisos de secciones">
          <Multiselect
            id="app-sections-select"
            v-model="select_app_section"
            :multiple="true"
            :options="appSectionsOptions"
            :loading="loadingAppSectionsOptions"
            :internal-search="false"
            @input="selectAppSectionProccess()"
            :custom-label="(opt) => labelOfAppSections(opt)"
            track-by="id"
            @search-change="asyncFindAppSections"
          >
          </Multiselect>
        </form-group>
      </form-wrapper>
    </b-form>
  </div>
</template>
